import { styled } from '@material-ui/core/styles';

export const Anchor = styled('a')(({ theme }) => ({
  color: theme.palette.primary.main,
  textDecoration: 'none',
}));
